import styled from 'styled-components';

// Styled components for the toggle switch
export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SwitchStyled = styled.label.attrs({
  className: 'switch'
})`
  position: relative;
  display: inline-block;
  width: 35px;
  height: 17px;
`;

export const HiddenCheckbox = styled.input.attrs({
  type: 'checkbox',
})`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #9aa9b2;
  transition: 0.4s;
  border-radius: 17px;

  &:before {
    position: absolute;
    content: "";
    height: 13px;
    width: 13px;
    border-radius: 50%;
    left: 4px;
    bottom: 2px;
    background-color: #404040;
    transition: 0.4s;
  }

  ${HiddenCheckbox}:checked + & {
    background-color: #008C57;
  }

  ${HiddenCheckbox}:checked + &::before {
    transform: translateX(13px);
    background-color: white
  }
`;
